export default __webpack_public_path__ + "static/media/yogaMind.e91ee874.png";